import { IGetOrdersParams } from "../../../modules/orderLog/domain/dtos/IGetOrdersParams";
import { IGetOrdersResponse } from "../../../modules/orderLog/domain/dtos/IGetOrdersResponse";
import { IOrderLogService } from "../../../modules/orderLog/domain/Interfaces/IOrderLogService";
import { Api } from "../bases/Api";
import { PORTAL_API_URL } from "../bases/Constants";

const api = Api();

const OrderLogService = (): IOrderLogService => {
    const getOrders = async (localId: string, params: IGetOrdersParams): Promise<IGetOrdersResponse> => {
        const response = await api.get(`${PORTAL_API_URL}/api/InvoiceGateway/Local/${localId}/Orders`, { params });
        return response.data;
    }
    
    return ({ getOrders })
}
export default OrderLogService
